import 'antd/dist/antd.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navigation from "./components/navigation/Navigation.jsx";
import ScrollToTop from "./components/navigation/ScrollToTop.jsx";
import PWAInstallPrompt from "./components/pwa/PWAInstallPrompt.jsx";

AOS.init();
export default function App() {
    return (
        <>
            <ScrollToTop/>
            <Navigation/>
            <PWAInstallPrompt/>
        </>
    )
}
